import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../constants/Routes';
import { useSelector } from 'react-redux';
import MainLayout from '../../components/Layout';

const ProtectedRoute = () => {
  const state = useSelector((state) => state);
  const accessToken = state.authenReducer.accessToken;
  if (accessToken) {
    return (
      <div>
        <MainLayout isMainPage />
      </div>
    );
  }
  return <Navigate replace to={ROUTES.Login} />;
};

export default ProtectedRoute;
